app.factory('sessionService', ['config', function (config) {

    var wdhash = 'wm3@@nljt3hsdh3sk';

    return {
        set: function (key, value) {
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            var encryptedData = CryptoJS.AES.encrypt(value, wdhash);
            return localStorage.setItem(config.BROKER_DEPLOYMENT_ID + key, encryptedData);
        },
        get: function (key) {
            var encryptedData = localStorage.getItem(config.BROKER_DEPLOYMENT_ID + key);
            if (encryptedData != null) {
                var value = CryptoJS.AES.decrypt(encryptedData, wdhash).toString(CryptoJS.enc.Utf8);
                try {
                    value = JSON.parse(value);
                } catch (error) {
                    if (value.startsWith('"') && value.endsWith('"'))
                        return value.slice(1, -1);
                }
                return value;
            }
            return null;
        },
        remove: function (key) {
            return localStorage.removeItem(config.BROKER_DEPLOYMENT_ID + key);
        },
        isLoggedIn: function () {
            if (this.get('id')) {
                const expiryTime = parseInt(this.get('expiresIn'));
                if (expiryTime) {
                    return expiryTime > new Date().getTime();
                } else {
                    return false
                }
            }
            return false;
        },
        isQcLoggedIn: function () {
            if (this.get('qcLogin')) {
                const qcExpiryTime = parseInt(this.get('qcExpiresIn'));
                if (qcExpiryTime) {
                    return qcExpiryTime > new Date().getTime();
                } else {
                    return false
                }
            } else {
                return false;
            }
        }
    }
}]);

app.factory('tempStorageService', ['config', function (config) {
    var wdhash = 'sm3!@nljd3hwdh8vc';
    return {
        set: function (key, value) {
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            var encryptedData = CryptoJS.AES.encrypt(value, wdhash);
            return sessionStorage.setItem(config.BROKER_DEPLOYMENT_ID + key, encryptedData);
        },
        get: function (key) {
            var encryptedData = sessionStorage.getItem(config.BROKER_DEPLOYMENT_ID + key);
            if (encryptedData != null) {
                var value = CryptoJS.AES.decrypt(encryptedData, wdhash).toString(CryptoJS.enc.Utf8);
                try {
                    value = JSON.parse(value);
                } catch (error) {
                    if (value.startsWith('"') && value.endsWith('"'))
                        return value.slice(1, -1);
                }
                return value;
            }
            return null;
        },
        remove: function (key) {
            return sessionStorage.removeItem(config.BROKER_DEPLOYMENT_ID + key);
        }
    }
}]);

app.factory('WdHttpService', ['$http', '$location', 'config', '$q', 'sessionService', 'analyticsService',
    function ($http, $location, config, $q, sessionService, analyticsService) {
        var cacheDeploymentIds = {};
        var cacheDeploymentDetails = {};
        var cacheEntityDetails = undefined;
        var cacheAdviserScores = {};
        var cacheAdviserUsernames = {};
        var cacheAdviserDetails = {};
        var cacheUserProfile = undefined;
        var cacheDynamoDBUserProfile = undefined;
        var cachedSubscribedFundList = undefined;
        var pendingActionsCache = undefined;
        var uploadTradesCache = undefined;
        var cachedInvestedFundList = undefined;

        function removeWdSession() {
            sessionService.remove('auth');
            sessionService.remove('id');
            sessionService.remove('refresh');
            sessionService.remove('cognito_username');
            sessionService.remove('ExpiresIn');
            sessionService.remove('qcExpiresIn');
            sessionService.remove('mode');
            sessionService.remove('brokerName');
            sessionService.remove('investingMode');
            sessionService.remove('distributorMapped');
            sessionService.remove('distributorName');
        }

        function error_handler(error) {
            if (error.status == "401" && error.data.message == "The incoming token has expired") {
                removeWdSession(sessionService);
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                $scope.hidePageLoader();
                $location.url('/register-client?returnToken=true&path=' + $location.absUrl());
                return "Unauthorized";
            } else if (error.data.message == 'Unauthorized') {
                removeWdSession(sessionService);
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                $scope.hidePageLoader();
                $location.url('/register-client?returnToken=true&path=' + $location.absUrl());
                return "Unauthorized";
            }
            return undefined;
        }

        function returnError(error) {
            var errorString = undefined;
            try {
                var common_error = error_handler(error);
                if (common_error)
                    errorString = common_error;
                if (error.data.message) {
                    if (typeof error.data.message == 'string')
                        errorString = error.data.message;
                    try {
                        var msg = JSON.parse(error.data.message);
                        errorString = msg.errorMessage;
                    } catch (error) { }
                    errorString = error.data.message;
                } else if (error.data.reason) {
                    errorString = error.data.reason;
                } else if (error.data.errorMessage) {
                    errorString = error.data.errorMessage;
                } else {
                    console.log(error);
                    errorString = error;
                }
            } catch (error) {
                errorString = 'Something went wrong, try again after some time.';
            }

            var eventData = {
                'errorString': errorString
            };
            analyticsService._push_custom_event_data_to_datalayer('WDAPIErrorMessage', eventData);

            return errorString;
        }

        function returnQCApiError(error) {
            try {
                if (error.data.message) {
                    return error.data.message;
                } else if (error.data.reason) {
                    return error.data.reason;
                } else if (error.data.errorMessage) {
                    return error.data.errorMessage;
                } else {
                    console.log(error);
                    return error;
                }
            } catch (error) {
                return 'Something went wrong, try again after some time.';
            }
        }

        function b64toBlob(b64Data, contentType) {
            contentType = contentType || '';
            var sliceSize = 512;
            b64Data = b64Data.replace(/^[^,]+,/, '');
            b64Data = b64Data.replace(/\s/g, '');
            var byteCharacters = window.atob(b64Data);
            var byteArrays = [];
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        }

        var obj = {
            _remove_wd_session: function () {
                removeWdSession();
            },
            _get_cognito_username: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'auth/cognito-username', { params: data })
                    .then(function (response) {
                        if (response.status == 200 && 'username' in response.data)
                            defer.resolve(response);
                        else
                            defer.reject(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _crypt: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'auth/crypt', { params: data })
                    .then(function (response) {
                        if (response.data.message) {
                            defer.resolve(response.data.message);
                        } else {
                            defer.resolve(response.data);
                        }
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _placed_order_details: function (data) {
                var defer = $q.defer();

                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'placed-order-details', data)
                    .then(response => defer.resolve(response.data))
                    .catch(error => defer.reject(returnError(error)));

                return defer.promise;
            },
            _log_in: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.post(config.API_ROOT_URL + 'auth/login', data)
                    .then(function (response) {
                        removeWdSession();
                        pendingActionsCache = undefined;
                        rejectedOrdersCache = undefined;
                        cacheUserProfile = undefined;
                        cacheDynamoDBUserProfile = undefined;
                        cachedSubscribedFundList = undefined;
                        cachedInvestedFundList = [];
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _is_user_invested_any_fund: async function (investingMode = 'REAL') {
                var defer = $q.defer();
                //using cached data of the User
                if (cachedInvestedFundList.length > 0) {
                    defer.resolve(true);
                    return defer.promise;
                }
                this._get_dynamodb_user_profile()
                    .then(function (userDDBProfile) {
                        if (userDDBProfile) {
                            cachedInvestedFundList = userDDBProfile.advisorToFunds;
                            var isInvestedInReal = cachedInvestedFundList.filter(fund => fund.investingMode == investingMode).length > 0;
                            if (isInvestedInReal) {
                                defer.resolve(true);
                            }
                        }
                        defer.resolve(false);
                    }).catch(function (error) {
                        console.log('Error is getting subscription details for the user.');
                        console.log(error);
                        defer.resolve(false);
                    });
                return defer.promise;
            },
            _get_adviserUsername: function (fundName) {
                var defer = $q.defer();
                if (cacheAdviserUsernames[fundName]) {
                    defer.resolve(cacheAdviserUsernames[fundName]);
                    return defer.promise;
                }
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'funds/funds-search', { params: { q: "fundName:" + fundName } })
                    .then(function (response) {
                        if (response.data.Items.length > 0) {
                            cacheAdviserUsernames[response.data.Items[0].fundName] = response.data.Items[0].adviserUsername;
                        }
                        defer.resolve(cacheAdviserUsernames[response.data.Items[0].fundName]);
                    }).catch(function (error) {
                        defer.reject(returnError(error));

                    });
                return defer.promise;
            },
            _get_entity_page_details: function (data) {
                var defer = $q.defer();
                if (cacheEntityDetails) {
                    defer.resolve(cacheEntityDetails);
                    return defer.promise;
                }
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'adviser/page-details', { params: data })
                    .then(function (response) {
                        cacheEntityDetails = response.data;
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(error);
                    });
                return defer.promise;
            },
            _get_adviser_details: function (data) {
                var defer = $q.defer();
                if (cacheAdviserDetails[data.adviserUsername]) {
                    defer.resolve(cacheAdviserDetails[data.adviserUsername]);
                    return defer.promise;
                }
                prepareBusinessAPIHttpCall($http, false);
                $http.get(config.BUSINESS_API_ROOT_URL + 'public/compliance/advisers/meta', { params: data })
                    .then(function (response) {
                        cacheAdviserDetails[data.adviserUsername] = response.data;
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(error);
                    });
                return defer.promise;
            },
            _get_adviser_scores_details: function (data) {
                var defer = $q.defer();
                if (cacheAdviserScores[data.adviserUsername]) {
                    defer.resolve(cacheAdviserScores[data.adviserUsername]);
                    return defer.promise;
                }
                prepareBusinessAPIHttpCall($http, false);
                $http.get(config.BUSINESS_API_ROOT_URL + 'public/compliance/advisers/scores', { params: data })
                    .then(function (response) {
                        cacheAdviserScores[data.adviserUsername] = response.data;
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(error);
                    });

                return defer.promise;
            },
            _get_pending_payments: async function () {
                var defer = $q.defer();

                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/expired_fee_data')
                    .then(function (response) {
                        defer.resolve(response.data.user_fund_expiration_data);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });

                return defer.promise;
            },
            _create_order_checksum: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/payment/create-order', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _is_fee_paid: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/payment/fee_paid', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(error => {
                        defer.reject(error);
                    });
                return defer.promise;
            },
            _get_all_pending_actions: async function (fromCache = false) {
                var defer = $q.defer();
                if (fromCache) {
                    if (pendingActionsCache) {
                        defer.resolve(pendingActionsCache);
                        return defer.promise;
                    }
                }
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/pending-orders/all')
                    .then(function (response) {
                        pendingActionsCache = response;
                        defer.resolve(response);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _payment_details: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/payment', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_funds: function (data) {
                var defer = $q.defer();
                prepareGatewayHttpCall($http, false);
                $http.get(config.GATEWAY_API_ROOT_URL + 'wealthbaskets', { params: data })
                    .then(function (response) {
                        if (response.data.Items.length > 0) {
                            cacheAdviserUsernames[response.data.Items[0].fundName] = response.data.Items[0].adviserUsername;
                        }
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));

                    });
                return defer.promise;
            },
            _fund_details_performace_graph: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL.replace('investor/', '') + 'common/compare-adviser-performance', { params: data })
                .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _my_portfolio_graph: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.get(config.API_ROOT_URL + 'compare-investor-performance', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _investor_orderbook: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/orderbook', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _my_transactions: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/investment-journey', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _notifications: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/notifications', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _user_composition: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/composition', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _my_portfolio: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/investor-performance-snapshot', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _refresh_my_portfolio: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/investor-performance-snapshot', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _user_fund: async function (data, adviserUsername, fund) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/investor-performance-snapshot/' + adviserUsername + '/' + fund + '', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _user_investments_data: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/funds/investments', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _user_transactions_data: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/funds/transactions', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _holdings_export: async function (adviserUsername, fund, data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                data.pdfType = "DETAILED";
                $http.get(deploymentDetails.apiUrl + '/investor/investor-performance-snapshot/' + adviserUsername + '/' + fund + '/' + 'holdings-export' + '', { params: data })
                    .then(function (response) {
                        if (response.data.filepath)
                            defer.resolve(response.data.filepath);
                        else
                            defer.reject("Server response is incorrect");
                    }).catch(error => {
                        $scope.showErrorPopup(error);
                    });
                return defer.promise;
            },
            _get_broker_url: async function () {
                var profile = await WdHttpService._cognito_profile();
                if (profile) {
                    for (let index = 0; index < profile.userAttributes.length; index++) {
                        const element = profile.userAttributes[index];
                        if (element.name == 'custom:brokerName1') {
                            if (config.OFFLINE_BROKERS.indexOf(element.value) > -1) {
                                return undefined;
                            } else {
                                return config[element.value].brokerPage;
                            }
                        }
                    }
                    return "MOCK_URL";
                }
                return undefined;
            },
            _cognito_profile: async function (noCache = true) {
                var defer = $q.defer();
                if (cacheUserProfile && !noCache) {
                    defer.resolve(cacheUserProfile);
                    return defer.promise;
                }
                prepareHttpCall($http, true);
                await $http.get(config.API_ROOT_URL + 'auth/profile')
                    .then(function (response) {
                        sessionService.set('profile', response.data);
                        sessionService.set("cognito_username", response.data.username);
                        cacheUserProfile = response.data;

                        if (window.fcWidget) {
                            // To set unique user id in your system when it is available
                            const name = response.data.userAttributes.filter(attr => attr.name == "name");
                            const email = response.data.userAttributes.filter(attr => attr.name == "email");
                            const phoneNumber = response.data.userAttributes.filter(attr => attr.name == "phoneNumber");
                            const firstName = name[0].value.split(' ')[0];
                            const lastName = name[0].value.split(' ')[1] ? name[0].value.split(' ')[1] : '';

                            if (email.length)
                                window.fcWidget.setExternalId(email[0].value);
                            else if (phoneNumber.length)
                                window.fcWidget.setExternalId(phoneNumber[0].value.substring(phoneNumber[0].value.length - 10));

                            window.fcWidget.user.setProperties({
                                firstName: firstName,
                                lastName: lastName,
                                email: email.length ? email[0].value : '',
                                phone: phoneNumber.length ? phoneNumber[0].value.substring(phoneNumber[0].value.length - 10) : '',
                                phoneCountry: phoneNumber.length ? phoneNumber[0].value.substring(0, 3) : '',
                                "plan": "Garden",
                                "status": "Active"
                            });
                        }
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _change_password: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'auth/change-password', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_wallet_balance: async function (data) {
                var defer = $q.defer();
                // As discussed with backend team, no need to show Wallet Amount and call the wallet endpoint

                defer.resolve(100000000);
                return defer.promise;
            },
            _get_stocks: function (data, adviserUsername, fund) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.get(config.API_ROOT_URL + 'subscription/' + adviserUsername + '/' + fund + '/demat', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_stock_splits: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.get(config.API_ROOT_URL + 'getStockSplit', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });

                return defer.promise;
            },
            _refresh_token: function (data, clearCache = false) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.post(config.API_ROOT_URL + 'auth/refresh-token', data)
                    .then(function (response) {
                        if (clearCache) {
                            removeWdSession();
                            pendingActionsCache = undefined;
                            rejectedOrdersCache = undefined;
                            cacheUserProfile = undefined;
                            cacheDynamoDBUserProfile = undefined;
                            cachedSubscribedFundList = undefined;
                            cachedInvestedFundList = [];
                        }
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _update_cognito_profile: function (attribute, value) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                var data = {
                    'attributeName': attribute,
                    'attributeValue': value
                }
                $http.patch(config.API_ROOT_URL + 'auth/profile', data)
                    .then(function (response) {
                        cacheUserProfile = undefined;
                        defer.resolve(response);
                    }).catch(function (error) {
                        // do not pass through error handler function to avoid redirection
                        defer.reject(error);
                    });

                return defer.promise;
            },
            _update_profile: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'auth/kyc-update', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _forgot_password: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'auth/forgot-password', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _resend_activation: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'auth/resend-activation', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_pending_sip: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/get-pending-sip', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));

                    });
                return defer.promise;
            },
            _reset_password: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.post(config.API_ROOT_URL + 'auth/forgot-password', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _send_code_again: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'auth/forgot-password', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _user_register: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.post(config.API_ROOT_URL + 'auth/register', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            add_investor: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'distributor/add_investor', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(error => {
                        defer.reject(error);
                    });
                return defer.promise;
            },
            _broker_client_register_and_kyc: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.post(config.API_ROOT_URL + 'auth/register-client', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _send_temporary_password_again: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'auth/resend-activation', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_user_full_name: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.get(config.API_ROOT_URL + 'auth/get-name', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _set_new_password: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, false);
                $http.post(config.API_ROOT_URL + 'auth/set-new-password', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _verify_code: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'auth/verify/confirmation', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _set_user_approval_mode: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'user-approval-mode', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_user_approval_mode: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'user-approval-mode', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _exit_fund: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.get(config.API_ROOT_URL + 'unsubscription', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_withdraw: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.get(config.API_ROOT_URL + 'withdraw', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _add_more_fund_get: function (data, adviserUsername, fund) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.patch(config.API_ROOT_URL + 'subscription/' + adviserUsername + '/' + fund + '/demat', data)
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _user_basket_approval: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'user-basket-approval', data)
                    .then(function (response) {
                        if (data.investingPurpose == 'PENDINGREBALANCEAPPROVALS')
                            pendingActionsCache = undefined;
                        if (data.investingPurpose == 'REJECTEDREBALANCEAPPROVALS')
                            rejectedOrdersCache = undefined;
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _qc_risk_profile_questions: function () {
                var defer = $q.defer();
                prepareHttpCallForQuantTech($http, true);

                $http.get(config.QC_API_URL + 'customer/risk-analyser-qn')
                    .then(function (response) {
                        defer.resolve(response.data.questions);
                    }).catch(function (error) {
                        defer.reject(returnQCApiError(error));
                    });
                return defer.promise;
            },
            _qc_risk_profile_submission: function (data) {
                var defer = $q.defer();
                prepareHttpCallForQuantTech($http, true);
                $http.post(config.QC_API_URL + 'customer/risk-analyser-qn-response', data)
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnQCApiError(error));
                    });
                return defer.promise;
            },
            _qc_risk_profile_details: function (data) {
                var defer = $q.defer();
                prepareHttpCallForQuantTech($http, true);
                $http.get(config.QC_API_URL + 'customer/risk-analyser-response', { params: data })
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnQCApiError(error));
                    });
                return defer.promise;
            },
            _qc_login: function () {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.get(config.API_ROOT_URL + 'qclogin')
                    .then(response => {
                        if (!angular.equals(response.data.authenticationResult, {})) {
                            sessionService.set('qcLogin', response.data.authenticationResult);
                            var expireIn = parseInt(response.data.authenticationResult.expiresIn) * 1000 + parseInt(new Date().getTime());
                            sessionService.set("qcExpiresIn", expireIn + "");
                            defer.resolve(response.data.authenticationResult);
                        } else {
                            defer.reject('Tokens are not received');
                        }
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_user_advisory_fee_amount: async function (fundName, adviserUsername, distributorName, investmentAmount, feePurpose, investingMode, investmentType) {
                var defer = $q.defer();
                var data = {
                    'fundName': fundName,
                    'adviserUsername': adviserUsername,
                    'investmentAmount': investmentAmount,
                    'investmentType': investmentType,
                    'investingMode': investingMode,
                    'purpose': feePurpose,
                    'distributorName': distributorName
                }
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/fee_amount', { params: data })
                    .then(function (response) {
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_deployment_id: function (brokerName) {
                var defer = $q.defer();

                if (cacheDeploymentIds[brokerName]) {
                    defer.resolve(cacheDeploymentIds[brokerName]);
                } else {
                    prepareHttpCall($http, true);
                    $http.get(config.API_ROOT_URL + 'deployment-id', { params: { 'brokerName': brokerName } })
                        .then(response => {
                            cacheDeploymentIds[brokerName] = response.data.deploymentId;
                            defer.resolve(response.data.deploymentId);
                        }).catch(error => {
                            defer.reject(returnError(error));
                        });
                }
                return defer.promise;
            },
            _get_deployment_details: function (deploymentId) {
                var defer = $q.defer();
                if (cacheDeploymentDetails[deploymentId]) {
                    defer.resolve(cacheDeploymentDetails[deploymentId]);
                } else {
                    prepareHttpCall($http, true);
                    $http.get(config.API_ROOT_URL + 'deployment-id/deployment-details', { params: { 'deploymentId': deploymentId } })
                        .then(response => {
                            cacheDeploymentDetails[deploymentId] = response.data;
                            defer.resolve(response.data);
                        }).catch(error => {
                            defer.reject(returnError(error));
                        });
                }
                return defer.promise;
            },
            _get_dynamodb_user_profile: async function (fromCache = true) {
                var defer = $q.defer();
                if (fromCache && cacheDynamoDBUserProfile) {
                    defer.resolve(cacheDynamoDBUserProfile);
                    return defer.promise;
                }
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/profile')
                    .then(function (response) {
                        if (response.data.Items[0]) {
                            cacheDynamoDBUserProfile = response.data.Items[0];
                            defer.resolve(response.data.Items[0]);
                        } else
                            defer.reject('User profile not found');
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_user_kyc_profile: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/register-and-kyc', data)
                    .then(function (response) {
                        cacheDynamoDBUserProfile = undefined;
                        defer.resolve(response);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_user_adviser_analyst_agreement_status: async function (adviserUsername) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/analyst-agreement/status', { params: { 'adviserUsername': adviserUsername } })
                    .then(function (response) {
                        defer.resolve(response.data.status);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_user_adviser_agreement: async function (fundName, adviserUsername, distributorName) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/advisor-agreement', { params: { 'fundName': fundName, 'adviserUsername': adviserUsername, 'distributorName': distributorName } })
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_user_adviser_agreement: async function (fundName, adviserUsername, OTP, agreementCopy, isResearchAnalyst) {
                var defer = $q.defer();
                var entityWiseUrl = 'analyst-agreement';
                var data = {
                    "agreementCopy": encodeURIComponent(JSON.stringify(agreementCopy)),
                    "format": "HTML",
                    "signingMethod": "USER_ACKNOWLEDGEMENT",
                    "signingParams": {},
                    "fundName": fundName,
                    "adviserUsername": adviserUsername
                }
                if (!isResearchAnalyst) {
                    data["signingMethod"] = "PHONE_BASED_VERIFICATION";
                    data["signingParams"] = { "otp": OTP.toString() };
                    entityWiseUrl = 'advisor-agreement';
                }
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/' + entityWiseUrl, data)
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_user_adviser_agreement_initiate: async function (fundName, adviserUsername, phoneNumber, isResearchAnalyst) {
                var defer = $q.defer();
                var entityWiseUrl = 'analyst-agreement';
                var data = {
                    "fundName": fundName,
                    "signingMethod": "USER_ACKNOWLEDGEMENT",
                    "signingParams": {},
                    "adviserUsername": adviserUsername
                }

                if (!isResearchAnalyst) {
                    data["signingMethod"] = "PHONE_BASED_VERIFICATION";
                    data["signingParams"] = {
                        "phoneNumber": phoneNumber
                    };
                    entityWiseUrl = 'advisor-agreement';
                }
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/' + entityWiseUrl + '/initiate-signing', data)
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_user_adviser_agreement_complete_signing: async function (fundName, adviserUsername, OTP, isResearchAnalyst) {
                var defer = $q.defer();
                var entityWiseUrl = 'analyst-agreement';
                var data = {
                    "fundName": fundName,
                    "signingMethod": "USER_ACKNOWLEDGEMENT",
                    "signingParams": {},
                    "adviserUsername": adviserUsername
                }
                if (!isResearchAnalyst) {
                    data["signingMethod"] = "PHONE_BASED_VERIFICATION";
                    data["signingParams"] = {
                        "otp": OTP.toString()
                    };
                    entityWiseUrl = 'advisor-agreement';
                }
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/' + entityWiseUrl + '/complete-signing', data)
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _fetch_kra_data: async function (adviserUsername, panNo, dateOfBirth) {
                var defer = $q.defer();
                // dateOfBirth is supposed to be a date time JS object
                //09122020 is the date format
                prepareGatewayHttpCall($http, true);
                var data = {
                    'adviserUsername': adviserUsername,
                    'pan': panNo,
                    'dob': '' + (dateOfBirth.getDate() > 9 ? dateOfBirth.getDate() : '0' + dateOfBirth.getDate()) +
                        (dateOfBirth.getMonth() > 8 ? dateOfBirth.getMonth() + 1 : '0' + (dateOfBirth.getMonth() + 1)) + dateOfBirth.getFullYear() //02022023
                }
                $http.get(config.GATEWAY_API_ROOT_URL + 'tpa/kra/pan-details', { params: data })
                    .then(function (response) {
                        try {
                            if (response.data.email || response.data.firstName || response.data.lastName || response.data.phoneNumber) {
                                defer.resolve(response.data);
                            }
                            else {
                                defer.reject("User detail could not be fetched");
                            }
                        } catch (error) {
                            defer.reject(error);
                        }
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_user_risk_profile: async function (fromCache = true) {
                var defer = $q.defer();
                this._get_dynamodb_user_profile(fromCache)
                    .then(function (userDDBProfile) {
                        if (userDDBProfile.riskProfile && userDDBProfile.riskProfile != "NONE") {
                            defer.resolve(userDDBProfile.riskProfile);
                        } else
                            defer.resolve(undefined);
                    }).catch(function (error) {
                        console.log(error);
                        defer.resolve(undefined);
                    });
                return defer.promise;
            },
            _post_user_risk_profile: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/risk-profile', data)
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _put_risk_profile: function (risk, fundName, adviserUsername, oldRiskValue) {
                var defer = $q.defer();
                var data = {
                    "fundName": fundName,
                    "adviserUsername": adviserUsername,
                    "newRiskValue": risk,
                    "oldRiskValue": oldRiskValue
                }
                prepareHttpCall($http, true);
                $http.put(config.API_ROOT_URL + 'risk-profile', data)
                    .then(function (response) {
                        defer.resolve(response.data);
                    }).catch(function (error) {
                        defer.reject(returnQCApiError(error));
                    });
                return defer.promise;
            },
            _check_advisory_fee: async function (fundName, adviserUsername) {
                var defer = $q.defer();
                this._user_composition({ fund: fundName, adviser: adviserUsername })
                    .then(function (response) {
                        if (response.data.isFeePaid) {
                            defer.resolve('PAID');
                        } else {
                            defer.resolve('NA');
                        }
                    }).catch(function (error) {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _upload_offline_trades: function (data) {
                var defer = $q.defer();
                prepareHttpCall($http, true);
                $http.post(config.API_ROOT_URL + 'upload-trade-file', { "data": data })
                    .then(response => {
                        console.log('done');
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_offline_trades: function (fromCache = false) {
                var defer = $q.defer();
                if (fromCache) {
                    if (uploadTradesCache) {
                        defer.resolve(uploadTradesCache);
                        return defer.promise;
                    }
                }
                prepareHttpCall($http, true);
                $http.get(config.API_ROOT_URL + 'offline-orders')
                    .then(response => {
                        uploadTradesCache = response.data;
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _is_user_invested: async function (fundName, investingMode = 'REAL') {
                var defer = $q.defer();
                //using cached data of the User
                if (cachedInvestedFundList) {
                    var tempFlag = false;
                    cachedInvestedFundList.forEach(element => {
                        if (element.fund == fundName) {
                            if (element.investingMode = investingMode)
                                tempFlag = true;
                        }
                    });
                    defer.resolve(tempFlag);
                    return defer.promise;
                }
                this._get_dynamodb_user_profile()
                    .then(function (userDDBProfile) {
                        if (userDDBProfile) {
                            var subscribedFunds = userDDBProfile.advisorToFunds;
                            cachedInvestedFundList = subscribedFunds;
                            var tempFlag = false;
                            for (let index = 0; index < subscribedFunds.length; index++) {
                                const element = subscribedFunds[index];
                                if (element.fund == fundName) {
                                    if (element.investingMode = investingMode) {
                                        tempFlag = true;
                                        break;
                                    }
                                }
                            }
                            defer.resolve(tempFlag);
                        } else
                            defer.resolve(false);
                    }).catch(function (error) {
                        console.log('Error is getting subscription details of the user for ' + fundName);
                        console.log(error);
                        defer.resolve(false);
                    });
                return defer.promise;
            },
            _post_initiate_esign: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/advisor-agreement/aadhar-esign/initiate-signing', data)
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_agreement_esign_status: async function (adviserUsername) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/advisor-agreement/aadhar-esign/status', { params: { "adviserUsername": adviserUsername } })
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_widget_token_validation: async function (data) {
                var defer = $q.defer();
                prepareGatewayHttpCall($http, false);
                $http.post(config.GATEWAY_API_ROOT_URL + 'esign/valid-widget-token', data)
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_mandate_status: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/payment/mandate/status', { params: data })
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_mandate_registration: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/payment/mandate/registration', data)
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_mandate_confirmation: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/payment/mandate/confirmation', data)
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_existing_mandate: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/payment/mandate/existing-mandate', data)
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _post_mandate_re_registration: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.post(deploymentDetails.apiUrl + '/investor/payment/mandate/re-registration', data)
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            },
            _get_paytm_payment_status: async function (data) {
                var defer = $q.defer();
                var deploymentDetails = await this._get_deployment_details(await this._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
                prepareHttpCall($http, true);
                $http.defaults.headers.common['x-api-key'] = deploymentDetails.apiKey;
                $http.get(deploymentDetails.apiUrl + '/investor/payment/status', { params: data })
                    .then(response => {
                        defer.resolve(response.data);
                    }).catch(error => {
                        defer.reject(returnError(error));
                    });
                return defer.promise;
            }

        }


        function prepareHttpCall($http, isEndpointAuthenticated) {
            if (isEndpointAuthenticated) {
                $http.defaults.headers.common['authorizationToken'] = sessionService.get("id");
            } else {
                $http.defaults.headers.common['authorizationToken'] = undefined;
            }
            $http.defaults.headers.common['x-api-key'] = config.API_ROOT_KEY;
            $http.defaults.headers.common['Content-Type'] = config.CONTENT_TYPE;
        }

        function prepareHttpCallForQuantTech($http, isEndpointAuthenticated) {
            if (isEndpointAuthenticated) {
                $http.defaults.headers.common['authorizationToken'] = sessionService.get("qcLogin").idToken;
            } else {
                $http.defaults.headers.common['authorizationToken'] = undefined;
            }
            $http.defaults.headers.common['x-api-key'] = config.QC_API_KEY;
            $http.defaults.headers.common['Content-Type'] = config.CONTENT_TYPE;
        }

        function prepareGatewayHttpCall($http, isEndpointAuthenticated) {
            if (isEndpointAuthenticated) {
                $http.defaults.headers.common['authorizationToken'] = sessionService.get("id");
            } else {
                delete $http.defaults.headers.common['authorizationToken'];
            }
            $http.defaults.headers.common['x-api-key'] = config.GATEWAY_API_ROOT_KEY;
            $http.defaults.headers.common['Content-Type'] = config.CONTENT_TYPE
        }

        function prepareBusinessAPIHttpCall($http, isEndpointAuthenticated) {
            if (isEndpointAuthenticated) {
                $http.defaults.headers.common['authorizationToken'] = sessionService.get("id");
            } else {
                delete $http.defaults.headers.common['authorizationToken'];
            }
            $http.defaults.headers.common['x-api-key'] = config.BUSINESS_API_ROOT_KEY;
            $http.defaults.headers.common['Content-Type'] = config.CONTENT_TYPE
        }
        return obj;

    }
]);